<template>
    <v-container fluid :class="{'px-0':esMovil}">
        <v-row no-gutters>
            <v-col cols="12">
                <v-row align="center" justify="center" :class="{'pa-2':!esMovil, 'ma-4':!esMovil,'mt-0':esMovil}"
                       :no-gutters="esMovil">
                    <v-card :width="esMovil ? '100%' : '500px'" :elevation="esMovil ? 0 : undefined">
                        <v-toolbar color="primary" dark flat>
                            <v-toolbar-title>{{ $t('inicio_sesion') }}</v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <login-component @loginCorrecto="loginCompletado"/>
                        </v-card-text>
                    </v-card>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import LoginComponent from "@/components/LoginComponent";
    import {mapState} from "vuex";
    import {VueRouteHelper} from "@/comunes/helpers/VueRouteHelper";

    export default {
        name: 'LoginPagina',
        components: {LoginComponent},
        data: () => ({}),
        computed: {
            ...mapState(["usuario"]),
            esMovil() {
                return this.$vuetify.breakpoint.smAndDown;
            }
        },
        watch: {},
        mounted() {
            if (this.usuario) this.goTo("/");
        },
        methods: {
            goTo(path) {
                VueRouteHelper.goTo(path, this.$router);
            },
            loginCompletado() {
                this.$gtag.event('inicio-sesion', {
                    'event_category': 'inicio-sesion',
                    'event_label': 'inicio-sesion',
                    'value': this.usuario
                });
                let pId = this.$store.getters.guardandoProyectoId;
                if (pId == null) this.goTo("/");
                else this.goTo(`/proyecto-detalles/${pId}`)
            }
        }
    };
</script>

<style lang="scss" scoped>
    .hand {
        cursor: pointer;
    }

    .hand:hover {
        text-decoration-line: underline;
    }
</style>

<i18n>
{
"es": {
"inicio_sesion": "Iniciar sesión"
}
}
</i18n>